
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificadoDigitalRequest } from 'src/app/models/CertificadoDigital/CertificadoDigitalRequest';
import { OrigenCertificadoEnum } from 'src/app/models/CertificadoDigital/OrigenCertificadoEnum';
import { CERT_PRECIOS } from 'src/app/components/configuracion-dte/mantenedor-certificados/config-certificados';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FacturacionIndividualService } from 'src/app/services/facturacion-individual.service';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { VerificacionRutValidator,validarRut } from 'src/app/directives/verifica-rut.directive';
import { formatToRut } from 'src/app/directives/formatToRut.directive';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';
import comunasData from 'src/app/models/CertificadoDigital/Comunas.json';
import { CertificadosDigitalesService } from 'src/app/services/certificados-digitales.service';
export type CertMode = 'generar' | 'comprar' | 'renovar';

@Component({
  selector   : 'app-certificado-form',
  templateUrl: './certificado-form.component.html',
  styleUrls  : ['./certificado-form.component.scss']
})
export class CertificadoFormComponent implements OnInit {
  @Input() mode: CertMode = 'generar';
  @Input() defaults: Partial<CertificadoDigitalRequest> = {}; 
  @Input() rutEmisor!: number;   
  @Input() comunas: string[] = (comunasData as string[]).sort();

  @Output() submitted = new EventEmitter<{
    payload: CertificadoDigitalRequest;
    total?: number;
    stopLoading:  () => void;
    closeModal?: () => void;
  }>();

  public certificadoForm!: FormGroup;
  public buscandoDatos = false;
  public existe         = true;
  public loading: boolean = false;
  
  public preciobase = 0;
  public precioGarantia = 0;
  public total = 0;
  public tablaPrecios: any[] = [];
  public periodos = [
    { value: 1, label: '1 Año' },
    { value: 2, label: '2 Años' },
    { value: 3, label: '3 Años' },
  ];

  private emisores: Emisor[];
  private sessionEmisor!: Emisor;
  private sessionEmisorId!: string;

  constructor(
    private fb     : FormBuilder,
    public  active : NgbActiveModal,
    private token  : TokenStorageService,
    private localStorageService     : LocalStorageService,
    private facturacionIndividualService   : FacturacionIndividualService,
     private certificadoService: CertificadosDigitalesService,
    private ref    : ChangeDetectorRef
  ) {
    this.sessionEmisorId = this.token.getCompany();
    this.emisores        = JSON.parse(this.localStorageService.getEmisores()) as Emisor[];
    this.sessionEmisor   = this.emisores.find(e => e.emisorId === this.sessionEmisorId)!;
  }
  ngOnInit(): void {
    this.buildForm();
    this.certificadoForm.patchValue(this.defaults);
    
    this.certificadoForm.get('duracion')!.valueChanges.subscribe(() => this.calcularPreciosCertificado());
    this.certificadoForm.get('garantia')!.valueChanges.subscribe(() => this.calcularPreciosCertificado());
    this.cargarTablaPrecios();
    this.calcularPreciosCertificado();
    if (this.mode === 'renovar') {
      this.certificadoForm.get('rut')!.disable({ emitEvent: false });
    } else {
      this.certificadoForm.get('rut')!.enable({ emitEvent: false });
    }
  }
  cargarTablaPrecios() {
    this.loading = true;
    this.certificadoService.getTarifasCertificado().subscribe({
      next: (data) => {
        this.tablaPrecios = this.periodos.map(periodo => {
          const precioCert = data.find(
            t => t.nombreProducto.toLowerCase() == "certificado digital" && t.anios === periodo.value
          );
          const precioGarantia = data.find(
            t => t.nombreProducto.toLowerCase().includes('garantía') && t.anios === periodo.value
          );
          return {
            duracion: periodo.value,
            precioCertificado: precioCert ? precioCert.precio : 0,
            precioGarantia: precioGarantia ? precioGarantia.precio : 0
          };
        });
        this.loading = false;
        this.ref.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.tablaPrecios = [];
        this.ref.detectChanges();
      }
    });
  }


  calcularPreciosCertificado() {
      const duracion = this.certificadoForm.get('duracion')!.value;
      const garantia = this.certificadoForm.get('garantia')!.value;

      if (!duracion) {
        this.preciobase = 0;
        this.precioGarantia = 0;
        this.total = 0;
        return;
      }
      const fila = this.tablaPrecios.find(p => p.duracion == duracion);
      this.preciobase = fila ? fila.precioCertificado : 0;
      this.precioGarantia = garantia && fila ? fila.precioGarantia : 0;
      this.total = Math.round((this.preciobase + this.precioGarantia) * 1.19);

      this.ref.detectChanges();
  }


  get periodoSel() {
    return this.periodos.find(p => p.value === this.certificadoForm.get('duracion')!.value);
  }
  onSubmit(): void {
    if (this.certificadoForm.invalid) return;
      this.loading = true;
      this.ref.detectChanges();
    const formValues = this.certificadoForm.getRawValue();
    let duracion: number;
    if (typeof formValues.duracion === 'string') {
        const match = formValues.duracion.match(/\d+/);
        duracion = match ? parseInt(match[0], 10) : 1;
    } else {
        duracion = parseInt(formValues.duracion, 10) || 1;
    }

    const payload: CertificadoDigitalRequest = {
        ...formValues,
        telefonoContacto: formValues.telefonoContacto ? String(formValues.telefonoContacto) : null,
        duracion: duracion,
        rutEmisor: this.rutEmisor.toString(),
        activo: true,
        origen: OrigenCertificadoEnum.Simplefactura,
        subtotal: this.preciobase + this.precioGarantia,
        iva: Math.round((this.preciobase + this.precioGarantia) * 0.19),
        neto: this.preciobase + this.precioGarantia,
        total: this.total
    };
    this.submitted.emit({
      payload,
      total: this.total,
      stopLoading: () => {
        this.loading = false;
        this.ref.detectChanges();
      },
      closeModal: () => {
        this.loading = false;
        this.ref.detectChanges();
        this.active.close();
      }
    });

  }
  buscaCliente(rutInput: string): void {
      const rut = rutInput.replace('.', '').replace('-', '');
      if (!rut || rut.length <= 7) { return; }

      if (!validarRut(rut)) {
        Swal.fire('Error de formato', 'Formato de RUT incorrecto', 'error');
        return;
      }

      const rutFmt = formatToRut(rut);
      this.certificadoForm.get('rut')!.setValue(rutFmt);

      this.buscandoDatos = true; this.ref.detectChanges();

      this.facturacionIndividualService.searchClient(rut, this.sessionEmisorId).subscribe({
        next: response => {
          this.buscandoDatos = false;
          if (response?.data?.length) {
            const cliente = response.data[0];
            this.existe = true;
            this.certificadoForm.patchValue({
              nombreEmpresa : cliente.razonSocial  || '',
              giroEmpresa   : cliente.giro    || '',
              direccion     : cliente.dirFact || cliente.dirPart || '',
              comuna        : cliente.comuna.toUpperCase() || this.sessionEmisor.comuna.toUpperCase(),
              correo        : cliente.correoFact   || cliente.correoPar
            });
            Swal.fire('Cliente encontrado','Se completaron datos automáticamente','success');
          } else {
            this.noExisteCliente();
          }
          this.ref.detectChanges();
        },
        error: () => { this.noExisteCliente(); }
      });
  }
  private noExisteCliente() {
    this.buscandoDatos = false;
    this.existe        = false;
    Swal.fire('Cliente no encontrado','Complete los datos manualmente', 'info');
    this.certificadoForm.patchValue({
      nombreEmpresa : this.sessionEmisor?.razonSocial || '',
      giroEmpresa   : this.sessionEmisor?.giro        || '',
      direccion     : this.sessionEmisor?.dirPart     || '',
      comuna        : this.sessionEmisor?.comuna      || '',
      correo        : this.sessionEmisor?.correoPar   || ''
    });
    this.ref.detectChanges();
  }


  private buildForm(): void {
    this.certificadoForm = this.fb.group({
      rut             : [null, [Validators.required, VerificacionRutValidator, Validators.maxLength(10)]],
      correo          : [null, [Validators.required, Validators.email]],
      duracion        : [null, Validators.required],
      nombreEmpresa   : [null, Validators.required],
      comuna          : [null, Validators.required],
      direccion       : [null, Validators.required],
      giroEmpresa     : [null, Validators.required],
      telefonoContacto: [null],
      garantia        : [false]
    });
  }
}
